$(function(){
  // 商品状態・保証専用のモーダル
  var conditionOpen = $('.modal-open-condition'),
    conditionClose = $('.modal-condition-warranty .modal-close'),
    conditionContainer = $('.modal-condition-warranty');

  //開くボタンをクリックしたらモーダルを表示する
  conditionOpen.on('click',function(){ 
    conditionContainer.addClass('active');
    return false;
  });

  //閉じるボタンをクリックしたらモーダルを閉じる
  conditionClose.on('click',function(){  
    conditionContainer.removeClass('active');
  });

  //モーダルの外側をクリックしたらモーダルを閉じる
  $(document).on('click',function(e) {
    if(!$(e.target).closest('.modal-condition-warranty .modal-body').length && conditionContainer.hasClass('active')) {
      conditionContainer.removeClass('active');
    }
  });
});
